import { useApiQuery } from "@/api";
import { FinanceLabField, getFinanceLabMetrics } from "@/entities/FinanceLab";
import clsx from "clsx";
import { useColorizedValue } from "../hooks/useColorizedValue";
import { useFlags } from "@/utils/flagsmith/useFlags";
import { DataSource } from "../hooks/useColorizedValue";
import { getLastValue } from "@/utils/metrics/metricsUtils";
import { ExpandableMarkdown } from "./ExpandableMarkdown";
import { LabelLLM } from "./LabelLLM";

export function InvestmentRationale() {
    const { data: rationale } = useApiQuery(getFinanceLabMetrics, {
        params: {
            labels: [FinanceLabField.DEAL_INVESTMENT_RATIONALE],
        },
    });
    const flags = useFlags();
    const showDataSources = flags.enabled("show-data-sources");

    const rationaleColorized = useColorizedValue(
        getLastValue(rationale?.[0]?.values)?.formattedValue || "-",
        DataSource.FINANCE_LAB,
        FinanceLabField.DEAL_INVESTMENT_RATIONALE,
    );

    return (
        <div>
            <div className="mb-2">
                <ExpandableMarkdown
                    text={rationaleColorized.value}
                    maxLength={1800}
                />
            </div>
            {showDataSources && rationaleColorized.source && (
                <span
                    className={clsx(
                        "mt-1 text-[9px] font-medium tracking-wide",
                        rationaleColorized.sourceClassName,
                    )}
                >
                    {rationaleColorized.source}
                </span>
            )}
            <LabelLLM />
        </div>
    );
}
